import * as Content from './Content'

function replacing(collection, contentId, content) {
  const oldContent = collection[contentId]
  if (content === oldContent) return collection

  return {
    ...collection,
    [contentId]: content,
  }
}

export function withContentSet(collection, contentId, content) {
  return replacing(collection, contentId, content)
}

export function withUpdates(collection, modified, removed) {
  const updatedCollection = {
    ...collection,
  }
  // eslint-disable-next-line
  for (const contentId in modified) {
    updatedCollection[contentId] = modified[contentId]
  }
  removed.forEach((contentId) => {
    delete updatedCollection[contentId]
  })
  return updatedCollection
}

export function withFolderAdded(collection, contentId, parentId) {
  return replacing(
    collection,
    contentId,
    Content.withFolderAdded(collection[contentId], parentId),
  )
}

export function withTextNodeAdded(collection, contentId, parentId) {
  return replacing(
    collection,
    contentId,
    Content.withTextNodeAdded(collection[contentId], parentId),
  )
}

export function withImageNodeAdded(collection, contentId, parentId, image) {
  return replacing(
    collection,
    contentId,
    Content.withImageNodeAdded(collection[contentId], parentId, image),
  )
}

export function withNodeMoved(
  collection,
  contentId,
  parentId,
  nodeId,
  newIndex,
) {
  return replacing(
    collection,
    contentId,
    Content.withNodeMoved(collection[contentId], parentId, nodeId, newIndex),
  )
}

export function withNodeRemoved(collection, contentId, parentId, nodeId) {
  return replacing(
    collection,
    contentId,
    Content.withNodeRemoved(collection[contentId], parentId, nodeId),
  )
}

export function withNodeRemovedIfEmpty(collection, contentId, nodeId) {
  return replacing(
    collection,
    contentId,
    Content.withNodeRemovedIfEmpty(collection[contentId], nodeId),
  )
}

export function withTitleSet(collection, contentId, nodeId, title) {
  return replacing(
    collection,
    contentId,
    Content.withTitleSet(collection[contentId], nodeId, title),
  )
}

export function withIconSet(collection, contentId, nodeId, icon) {
  return replacing(
    collection,
    contentId,
    Content.withIconSet(collection[contentId], nodeId, icon),
  )
}

export function withTextSet(collection, contentId, nodeId, text) {
  return replacing(
    collection,
    contentId,
    Content.withTextSet(collection[contentId], nodeId, text),
  )
}

export function withImageSet(collection, contentId, nodeId, image) {
  return replacing(
    collection,
    contentId,
    Content.withImageSet(collection[contentId], nodeId, image),
  )
}

function usedEmojis(collection) {
  const icons = new Set()
  // eslint-disable-next-line
  for (const contentId in collection) {
    const content = collection[contentId]
    if (content.icon !== undefined) {
      icons.add(content.icon)
    }
  }
  return [...icons]
}

export function randomUnusedEmoji(collection) {
  return Content.randomEmojiExcluding(usedEmojis(collection))
}
